import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from "../../../../../core/service/v2/abstractRepositoryV2";
import {ReportComponentDefinitionModel} from "../../../api/entity/reportComponentDefinition.model";

@Injectable()
export class ReportComponentDefinitionRepository extends AbstractRepositoryV2<ReportComponentDefinitionModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('ReportComponentDefinition', serviceElementsFactory, injector);
    }
}
